import classNames from 'classnames';
import React, { useContext } from 'react';
import { useSelector } from 'store';
import { ThemeContext } from 'styled-components';

import Icon from 'components/Icon';

import {
    IconContainer,
    InputContainer,
    DatePickerLabel,
    DatePickerValue,
} from './DatePickerStyles';
import { selectBrowser } from 'store/slices/browser';

const scrollBehaviour = { behavior: 'smooth' };

const DatePicker = ({
    inputId,
    label,
    date,
    focused,
    format,
    openCalendar,
    className,
    pickingEnd,
    updatePickingEnd,
    updateCurrent,
}) => {
    const themeContext = useContext(ThemeContext);
    const pickerClass = { active: focused };
    const containerRef = React.createRef();
    const browser = useSelector(selectBrowser);

    const clickHandler = () => {
        if (browser.size !== 'lg') {
            containerRef.current.scrollIntoView(scrollBehaviour);
        }
        updatePickingEnd(pickingEnd);
        updateCurrent(date);
        openCalendar();
    };

    return (
        <div
            className={classNames(className, pickerClass)}
            onClick={clickHandler}
            ref={containerRef}
            // eslint-disable-next-line indent
        >
            <IconContainer>
                <Icon
                    type="checkin-toggle"
                    width="21px"
                    height="23px"
                    colour={themeContext.colours.primary}
                />
            </IconContainer>
            <InputContainer>
                <input
                    value={date.format(format)}
                    id={inputId}
                    className="datepicker-input"
                    readOnly
                />
            </InputContainer>
            <DatePickerLabel>{label}</DatePickerLabel>
            <DatePickerValue>{date.format(format)}</DatePickerValue>
        </div>
    );
};

export default DatePicker;
